<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">룸 관리</span>
            <span class="txt">공간을 분리하여 사용하는 경우 룸을 설정하고, 스케줄 예약 시 룸 선택이 가능합니다.</span>
        </div>
        <div class="com-search-content">
            <div class="line">
                <div class="com-radio-txt">
                    <input
                        id="check-1-1"
                        v-model="filter"
                        :checked="filter === null"
                        :value="null"
                        name="check-1"
                        type="radio"
                    />
                    <label for="check-1-1">전체</label>
                </div>
                <div class="com-radio-txt">
                    <input
                        id="check-1-2"
                        v-model="filter"
                        :checked="filter"
                        :value="true"
                        name="check-1"
                        type="radio"
                    />
                    <label for="check-1-2">예약 가능한 룸</label>
                </div>
                <div class="com-radio-txt">
                    <input
                        id="check-1-3"
                        v-model="filter"
                        :checked="filter === false"
                        :value="false"
                        name="check-1"
                        type="radio"
                    />
                    <label for="check-1-3">예약 불가한 룸</label>
                </div>
                <div class="com-search-input">
                    <input
                        ref="keyword"
                        placeholder="이름 입력"
                        type="text"
                        @keyup.enter="search"
                        @keyup.esc="
                            keyword = '';
                            $event.target.value = '';
                        "
                    />
                    <button class="search-btn" @click="search">검색</button>
                </div>
            </div>
        </div>
        <div class="com-btn-area">
            <div class="right-box">
                <a class="com-btn blue" href="#" @click="add">룸 등록</a>
            </div>
        </div>
        <div class="com-table-content">
            <loading-spinner v-if="isLoading"></loading-spinner>
            <table v-else class="com-table">
                <colgroup>
                    <col style="width: 220px" />
                    <col style="width: 220px" />
                    <col style="width: 560px" />
                    <col style="width: 120px" />
                    <col style="width: 120px" />
                    <col style="width: 160px" />
                    <col style="width: 160px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>상태</th>
                        <th>룸 이름</th>
                        <th>설명</th>
                        <th>사용여부</th>
                        <th>입실인원</th>
                        <th>관리</th>
                        <th>수정일</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="room in list" :key="room.centerRoomId">
                        <td>
                            <span v-if="room.reserveYn" class="blue">예약 가능한 룸</span>
                            <span v-else class="red">예약 불가한 룸</span>
                        </td>
                        <td>{{ room.name }}</td>
                        <td class="left">{{ room.memo }}</td>
                        <td>{{ room.reserveYn ? '사용' : '미사용' }}</td>
                        <td>
                            <template v-if="room.limitYn">{{ room.limitCount }}명</template>
                            <template v-else>제한없음</template>
                        </td>
                        <td>
                            <button class="com-btn small" type="button" @click="edit(room)">수정</button>
                        </td>
                        <td>{{ room.info.updatedAt | timestampFilter }}</td>
                    </tr>
                    <tr v-if="list.length == 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- 룸 등록/수정 팝업 -->
        <div v-show="roomPop" class="layer-pop square-type">
            <form ref="form" class="view-content w660" onsubmit="return false">
                <button class="close" @click="roomPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span v-if="popState === 'add'" class="sub-title">룸 등록</span>
                    <span v-if="popState === 'edit'" class="sub-title">룸 수정</span>
                    <table class="com-table left">
                        <colgroup>
                            <col style="width: 160px" />
                            <col style="width: 350px" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>룸 이름</th>
                                <td>
                                    <input v-model="info.name" class="w100p" maxlength="50" required type="text" />
                                </td>
                            </tr>
                            <tr>
                                <th>설명</th>
                                <td>
                                    <textarea v-model="info.memo" class="text-field"></textarea>
                                </td>
                            </tr>
                            <tr>
                                <th>입실인원</th>
                                <td>
                                    <div class="line">
                                        <div class="com-radio">
                                            <input
                                                id="radio-pop-1-1"
                                                v-model="info.limitYn"
                                                :value="true"
                                                name="radio-pop-1"
                                                type="radio"
                                            />
                                            <label for="radio-pop-1-1">인원한정</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-pop-1-2"
                                                v-model="info.limitYn"
                                                :value="false"
                                                name="radio-pop-1"
                                                type="radio"
                                            />
                                            <label for="radio-pop-1-2">인원제한 없음</label>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <input
                                            v-model="info.limitCount"
                                            :disabled="!info.limitYn"
                                            class="w60 center"
                                            placeholder="예 ) 3"
                                            type="text"
                                        />
                                        <span class="txt">명</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>사용여부</th>
                                <td>
                                    <div class="line">
                                        <div class="com-radio">
                                            <input
                                                id="radio-pop-2-1"
                                                v-model="info.reserveYn"
                                                :value="true"
                                                name="radio-pop-2"
                                                type="radio"
                                            />
                                            <label for="radio-pop-2-1">사용</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-pop-2-2"
                                                v-model="info.reserveYn"
                                                :value="false"
                                                name="radio-pop-2"
                                                type="radio"
                                            />
                                            <label for="radio-pop-2-2">미사용</label>
                                        </div>
                                    </div>
                                    <div class="line">
                                        <span class="notice-star">
                                            미사용 클릭 시 해당 룸이 예약페이지에서 보이지 않습니다.
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- 룸 수정시만 -->
                    <div v-if="info.centerRoomId != undefined" class="com-btn-area">
                        <div class="right-box">
                            <button :disabled="isSaving" class="com-btn red" type="button" @click="remove">삭제</button>
                        </div>
                    </div>
                    <!-- //룸 수정시만 -->
                    <div class="bottom-btn">
                        <button class="com-btn" type="button" @click="roomPop = false">취소</button>
                        <button :disabled="isSaving" class="com-btn blue" type="button" @click="save">등록</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import api from '../../../assets/js/api';

export default {
    name: 'SettingRoom',
    props: {},
    data() {
        return {
            roomPop: false,
            isLoading: false,
            isSaving: false,
            filter: null,
            keyword: '',
            popState: '',
            data: [],
            info: {},
        };
    },
    computed: {
        list() {
            return this.data.filter((o) => {
                return o.name.search(this.keyword) >= 0 && (this.filter === null || this.filter == o.reserveYn);
            });
        },
        centerId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            this.isLoading = true;
            // 스웨거 검색: 센터 룸 조회
            api.get('/admin/api/centerRoom/' + this.centerId)
                .then((res) => {
                    this.isLoading = false;
                    this.data = res.data;
                    console.log('정보', res.data);
                })
                .catch((res) => {
                    this.isLoading = false;
                    alert(`오류가 발생했습니다.\n${res.message}`);
                    console.error(res);
                });
        },
        search() {
            this.keyword = this.$refs.keyword.value;
        },
        add() {
            this.info = {
                useYn: true,
                limitYn: false,
            };
            this.roomPop = true;
            this.popState = 'add';
        },
        edit(room) {
            this.info = { ...room };
            this.roomPop = true;
            this.popState = 'edit';
        },
        save() {
            if (!this.$refs.form.checkValidity()) {
                return;
            }

            this.isSaving = true;
            this.info.centerId = this.centerId;
            (this.info.centerRoomId
                ? api.put('/admin/api/centerRoom/update', this.info)
                : api.post('/admin/api/centerRoom/create', this.info)
            )
                .then((res) => {
                    this.isSaving = false;
                    // alert('저장했습니다.');
                    this.roomPop = false;
                    this.load();
                })
                .catch((res) => {
                    this.isSaving = false;
                    alert(`오류가 발생했습니다.\n${res.message}`);
                    console.error(res);
                });
        },
        remove() {
            if (!confirm('삭제하시겠습니까?')) {
                return;
            }

            this.isSaving = true;
            api.delete(`/admin/api/centerRoom/${this.centerId}/${this.info.centerRoomId}`)
                .then((res) => {
                    this.isSaving = false;
                    alert('삭제했습니다.');
                    this.roomPop = false;
                    this.load();
                })
                .catch((res) => {
                    this.isSaving = false;
                    alert(`오류가 발생했습니다.\n${res.message}`);
                    console.error(res);
                });
        },
    },
};
</script>
<style lang="scss"></style>
